import _ from 'lodash'
import { ADD_ERROR, ADD_WARNING, ADD_SUCCESS, ADD_INFO } from './constants'
import { REMOVE_TOAST, REMOVE_TOASTS } from '../constants'

// Initial state of the store
const initialState = {}

function isSame(oldNotification, newNotification) {
    if (oldNotification.queue !== newNotification.queue) return false
    if (oldNotification.alwaysOnTop !== newNotification.alwaysOnTop) return false
    if (oldNotification.severity !== newNotification.severity) return false

    return true
}

// Commands for the state machine
const notifications = (state = initialState, action) => {
    const { payload, type } = action
    switch (type) {
        // Read given object into state
        case ADD_ERROR:
        case ADD_WARNING:
        case ADD_SUCCESS:
        case ADD_INFO: {
            // Get the notification in state
            let notification = _.cloneDeep(state[payload.id])

            if (
                // This is a new notification
                notification == null ||
                // New queue or severity
                !isSame(notification, payload) ||
                // If user has already dismissed this notification earlier
                // How long ago since we last received this message
                // If more than a minute has passed since we last dismissed this
                // notification, then and only then add it again
                (notification.dismissed != null && payload.created - notification.dismissed > 59999)
            ) {
                notification = payload
            } else {
                // User has not dismissed this previously
                // Now we need to update all the updatable fields...
                notification.dismissible = payload.dismissible
                notification.timeout = payload.timeout
                notification.count += 1
                notification.countSinceLastDismissal += 1
                notification.updated = payload.updated
                notification.title = payload.title
                notification.content = payload.content
                notification.dismissed = null
            }

            return {
                ...state,
                [notification.id]: notification,
            }
        }

        // Dismiss a notification
        case REMOVE_TOAST: {
            // Don't process messages
            if (payload.isMessage) return state

            const notification = _.cloneDeep(state[payload.id])
            if (notification == null) return state

            // Mark the notification as seen and reset the count since last dismissed
            notification.seen = true
            notification.countSinceLastDismissal = 0

            if (!notification.dismissible) {
                return {
                    ...state,
                    [notification.id]: notification,
                }
            }

            notification.dismissed = payload.dismissed

            return {
                ...state,
                [notification.id]: notification,
            }
        }

        // Dismiss all given notifications
        case REMOVE_TOASTS: {
            if (payload.ids == null || payload.ids.length < 1) return state

            // Clone the entire notifications object
            const notes = _.cloneDeep(state)
            if (_.isEmpty(notes)) return state

            // Loop through the given ids, and update the state
            // accordingly
            payload.ids.map((id) => {
                const notification = notes[id]

                // No notification with given id found
                if (notification == null) {
                    return 0
                }

                // Mark the notification as seen and reset the count since last dismissed
                notification.seen = true
                notification.countSinceLastDismissal = 0

                if (!notification.dismissible) {
                    return 0
                }

                notification.dismissed = payload.dismissed

                return 0
            })

            return notes
        }

        // Default state
        default:
            return state
    }
}

export default notifications



// WEBPACK FOOTER //
// ./src/features/Toaster/data/notifications/reducer.js